export enum ValidationType {
	TEST_RESULT_MANUAL_INPUT = "TEST_RESULT_MANUAL_INPUT",
	GENERIC_MANUAL_INPUT = "GENERIC_MANUAL_INPUT",
	PHOTOS = "PHOTOS",
	FORM = "FORM",
	ATTENDANCE = "ATTENDANCE",
	COMPOUND = "COMPOUND",
	WATCH_VIDEO = "WATCH_VIDEO",
	CAPTURE_VIDEO = "CAPTURE_VIDEO",
}

export enum CompletionRequirement {
	ALL_REQUIRED = "ALL_REQUIRED",
	ALL_STEPS = "ALL_STEPS",
	REQUIRED_ONLY = "REQUIRED_ONLY",
}

export interface EventResult {
	_id?: string;
	id: string;
	display: string;
	tamperedDisplayText?: string;
	shortName?: string;
	displayColor?: string;
	allowForEntrySelection: boolean;
	allowForEditionWithOutPerm: boolean;
	validResult: boolean;
	disenrollmentJobStatus?: boolean;
	requireConfirmation?: boolean;
	missEntry?: boolean;
	showAnalytes?: boolean;
}

export interface EventKPI {
	name: string;
	url: string;
	active?: boolean;
	position?: number;
	variables?: Array<{ name: string; value: string }>;
}

export interface SectionConfig {
	action: string;
	position: number;
	title: string;
	customStructure?: Record<string, unknown>;
}

export interface PhotoConfig {
	minPhotos: number;
	maxPhotos: number;
	sequentialCapture?: boolean;
	allowRetake?: boolean;
}

export interface FormConfig {
	surveySchema: Record<string, unknown>;
	surveySchemaVersion: string;
	uploadedAt?: string;
	uploadedBy?: string;
}

export interface CompoundStep {
	order: number;
	eventId: string;
	required?: boolean;
}

export interface CompoundConfig {
	steps: CompoundStep[];
	allowPartialSubmission?: boolean;
	completionRequirement?: CompletionRequirement;
}

export interface DefaultSubmissionWindow {
	duration: number;
	unit: string;
	reason?: string;
}

export interface NotificationMetadata {
	notificationTitle?: string;
	notificationMessage?: string;
	reminderTitle?: string;
	reminderMessage?: string;
	activityDescription?: string;
	timingGuidance?: string;
}

export interface VideoConfig {
	// Watch_Video fields
	videoUrl?: string;
	videoId?: string;
	duration?: number;
	title?: string;
	description?: string;
	thumbnailUrl?: string;
	minWatchPercentage?: number;
	allowSkip?: boolean;
	// Capture_Video fields
	maxDuration?: number;
	minDuration?: number;
	allowRetake?: boolean;
	uploadFormat?: string;
}

export interface Event {
	_id: string;
	name: string;
	verificationType: "Manual" | "Automatic";
	validationType: ValidationType;
	requireMobileValidation?: boolean;
	cupsAndAnalytes?: boolean;
	eventResults?: EventResult[];
	dashboardKPIs?: EventKPI[];
	profileStatisticsKPIs?: EventKPI[];
	sectionConfig?: SectionConfig;
	photoConfig?: PhotoConfig;
	formConfig?: FormConfig;
	compoundConfig?: CompoundConfig;
	videoConfig?: VideoConfig;
	isSubEvent?: boolean;
	defaultSubmissionWindow?: DefaultSubmissionWindow;
	accountId?: string | null;
	notificationMetadata?: NotificationMetadata;
	createdAt: string;
	updatedAt: string;
}

export interface EventRequest {
	name: string;
	verificationType: "Manual" | "Automatic";
	validationType: ValidationType;
	requireMobileValidation?: boolean;
	cupsAndAnalytes?: boolean;
	eventResults?: EventResult[];
	dashboardKPIs?: EventKPI[];
	profileStatisticsKPIs?: EventKPI[];
	sectionConfig?: SectionConfig;
	photoConfig?: PhotoConfig;
	formConfig?: FormConfig;
	compoundConfig?: CompoundConfig;
	videoConfig?: VideoConfig;
	isSubEvent?: boolean;
	defaultSubmissionWindow?: DefaultSubmissionWindow;
	accountId?: string | null;
	notificationMetadata?: NotificationMetadata;
	createdBy?: string;
	updatedBy?: string;
}
